
export interface EnumDto {
  value: number;
  name?: string;
}
